import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BasePage from '../../components/Layout/BasePage';
import SalesCostingOverview from '../Costing/SalesCostingOverview';
import ProductionCostingOverview from '../Costing/ProductionCostingOverview';
import ProfitMarginsOverview from '../Costing/ProfitMarginsOverview';
import BomVarianceReport from '../Costing/BomVarianceReport';
import './SupervisorHomePage.css';  // Reuse tab styling

const CostingHomePage = () => {
  const { t } = useTranslation('common');
  const [activeTab, setActiveTab] = useState(() =>
    sessionStorage.getItem('costingActiveTab') || 'sales'
  );
  const [activeSubTab, setActiveSubTab] = useState(() =>
    sessionStorage.getItem('costingActiveSubTab') || 'overview'
  );

  useEffect(() => {
    sessionStorage.setItem('costingActiveTab', activeTab);
  }, [activeTab]);

  useEffect(() => {
    sessionStorage.setItem('costingActiveSubTab', activeSubTab);
  }, [activeSubTab]);

  const tabConfig = {
    'sales': {
      name: t('costingHomePage.tabs.sales'),
      icon: '💵',
      subtabs: {
        'overview': { name: t('costingHomePage.tabs.overview'), icon: '📊' }
      }
    },
    'production': {
      name: t('costingHomePage.tabs.production'),
      icon: '🏭',
      subtabs: {
        'overview': { name: t('costingHomePage.tabs.overview'), icon: '📊' },
        'variance': { name: t('costingHomePage.tabs.bomVariance'), icon: '⚖️' }
      }
    },
    'margins': {
      name: t('costingHomePage.tabs.margins'),
      icon: '📊',
      subtabs: {
        'overview': { name: t('costingHomePage.tabs.overview'), icon: '📊' }
      }
    }
  };

  const renderTabContent = () => {
    if (activeTab === 'sales') {
      return <SalesCostingOverview />;
    }
    if (activeTab === 'production') {
      return activeSubTab === 'variance' ? <BomVarianceReport /> : <ProductionCostingOverview />;
    }
    if (activeTab === 'margins') {
      return <ProfitMarginsOverview />;
    }
    return null;
  };

  return (
    <BasePage title={t('costingHomePage.title')} className="supervisor-home-page">
      <div className="supervisor-navigation">
        <div className="main-tabs">
          {Object.entries(tabConfig).map(([tabId, tab]) => (
            <button
              key={tabId}
              className={`main-tab ${activeTab === tabId ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(tabId);
                setActiveSubTab(Object.keys(tab.subtabs)[0]);
              }}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.name}</span>
            </button>
          ))}
        </div>
        <div className="sub-tabs">
          <div className="subtabs-left">
            {tabConfig[activeTab]?.subtabs &&
              Object.entries(tabConfig[activeTab].subtabs).map(([subTabId, subTab]) => (
                <button
                  key={subTabId}
                  className={`sub-tab ${activeSubTab === subTabId ? 'active' : ''}`}
                  onClick={() => setActiveSubTab(subTabId)}
                >
                  <span className="subtab-icon">{subTab.icon}</span>
                  <span className="subtab-label">{subTab.name}</span>
                </button>
              ))}
          </div>
        </div>
      </div>
      <div className="supervisor-content">
        {renderTabContent()}
      </div>
    </BasePage>
  );
};

export default CostingHomePage;
